import { render, staticRenderFns } from "./About.vue?vue&type=template&id=6eea6318"
import script from "./About.ts?vue&type=script&lang=ts&external"
export * from "./About.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports